import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NotInterestedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"not_interested"}/>
}
